import { render, staticRenderFns } from "./MoleculeEditionAssetCommentsReplies.vue?vue&type=template&id=b9eda97a&"
import script from "./MoleculeEditionAssetCommentsReplies.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetCommentsReplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports